import { useMemo } from "react"
import { z } from "zod"

export const SPECIAL_CHARS = "#!?@$_%^&*-"

export const escapeForRegex = (str: string) => str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")

export const passwordRules = [
  {
    test: (v: string) => v.length >= 6,
    message: "At least 6 characters",
  },
  /*{
    test: (v: string) => /[A-Z]/.test(v),
    message: "At least one uppercase letter",
  },*/
  {
    test: (v: string) => /[a-z]/.test(v),
    message: "At least one lowercase letter",
  },
  {
    test: (v: string) => /[0-9]/.test(v),
    message: "At least one number",
  },
  {
    test: (v: string) => new RegExp(`[${escapeForRegex(SPECIAL_CHARS)}]`).test(v),
    message: `At least one special character (${SPECIAL_CHARS})`,
  },
]

export function getFailedPasswordRules(value: string) {
  return passwordRules.filter((rule) => !rule.test(value))
}

export function usePasswordRules(value: string) {
  // Returns [failedRules, allRules] for convenience
  return useMemo(() => {
    const failed = getFailedPasswordRules(value)
    return [failed, passwordRules] as const
  }, [value])
}

export const passwordSchema = z
  .string()
  .min(6, { message: "Password must be at least 6 characters" })
  /*.regex(/[A-Z]/, { message: "Password must contain an uppercase letter" })*/
  .regex(/[a-z]/, { message: "Password must contain a lowercase letter" })
  .regex(/[0-9]/, { message: "Password must contain a number" })
  .regex(new RegExp(`[${escapeForRegex(SPECIAL_CHARS)}]`), {
    message: `Password must contain a special character (${SPECIAL_CHARS})`,
  })
